import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';
import intellientLogoEnglish from '../assets/logo/intellientLogoEnglish.png';
import intellientLogoArabic from '../assets/logo/intellientLogoArabic.png';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-container">
      <div className="header-inner">

        {/* ── LEFT: Logo ── */}
        <div className="header-left">
          <Link to="/" className="logo-link" aria-label="Intellient Solutions home">
            <img
              src={intellientLogoEnglish}
              alt="Intellient Solutions"
              className="header-logo"
              width="185"
              height="65"
            />
          </Link>

          {/* Mobile Hamburger */}
          <button
            className={`hamburger-btn ${mobileMenuOpen ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle mobile menu"
            aria-expanded={mobileMenuOpen}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>

        {/* ── RIGHT: Nav + CTA ── */}
        <div className={`header-right ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <nav className="nav-container" aria-label="Main navigation">

            {/* Desktop nav links */}
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              <i className="ti ti-home" aria-hidden="true"></i>
              Home
            </Link>

            <span className="nav-sep" aria-hidden="true" />

            <Link to="/services" className={`nav-link ${isActive('/services') ? 'active' : ''}`}>
              Capabilities
            </Link>

            <span className="nav-sep" aria-hidden="true" />

            <Link to="/case-studies" className={`nav-link ${isActive('/case-studies') ? 'active' : ''}`}>
              Case Studies
            </Link>

            <span className="nav-sep" aria-hidden="true" />

            <Link to="/about-us" className={`nav-link ${isActive('/about-us') ? 'active' : ''}`}>
              About Us
            </Link>

            {/* Mobile Navigation (shown inside nav on small screens) */}
            <div className="mobile-nav" role="menu">

              <Link
                to="/"
                className={`mobile-nav-link ${isActive('/') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
                role="menuitem"
              >
                <i className="ti ti-home" aria-hidden="true"></i>
                Home
              </Link>

              <span className="mob-sep" aria-hidden="true" />

              <Link
                to="/services"
                className={`mobile-nav-link ${isActive('/services') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
                role="menuitem"
              >
                <i className="ti ti-settings" aria-hidden="true"></i>
                Capabilities
              </Link>

              <span className="mob-sep" aria-hidden="true" />

              <Link
                to="/case-studies"
                className={`mobile-nav-link ${isActive('/case-studies') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
                role="menuitem"
              >
                <i className="ti ti-file-text" aria-hidden="true"></i>
                Case Studies
              </Link>

              <span className="mob-sep" aria-hidden="true" />

              <Link
                to="/about-us"
                className={`mobile-nav-link ${isActive('/about-us') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
                role="menuitem"
              >
                <i className="ti ti-users" aria-hidden="true"></i>
                About Us
              </Link>

              <span className="mob-sep" aria-hidden="true" />

              {/* Mobile CTA */}
              <Link
                to="/contact"
                className={`mobile-connect-btn ${isActive('/contact') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
                role="menuitem"
              >
                <i className="ti ti-message" aria-hidden="true"></i>
                Let's Connect
              </Link>
            </div>
          </nav>
          {/* Desktop CTA */}
          <Link to="/contact" className={`connect-btn ${isActive('/contact') ? 'active' : ''}`}>
            <span className="connect-dot" aria-hidden="true"></span>
            Let's Connect
          </Link>
          {/* Arabic Logo (desktop only) */}
          <Link to="/" className="logo-link logo-arabic" aria-label="Intellient Solutions home">
            <img
              src={intellientLogoArabic}
              alt="Intellient Solutions"
              className="header-logo-arabic"
              width="155"
              height="55"
            />
          </Link>
        </div>

      </div>
    </header>
  );
}

export default Header;